export enum HebergementFunnelOrigin {
  MES_HEBERGEMENTS = "mes_hebergements",
  DECLARATION_SEJOUR = "declaration_sejour",
}

export enum HEBERGEMENT_STATUT {
  BROUILLON = "BROUILLON",
  ACTIF = "ACTIF",
  DESACTIVE = "DESACTIVE",
}
